import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { Redirect } from 'react-router';

import HandleQuery from '@components/HandleQuery';
import ExpertJourneyPage from '@components/pageTypes/ExpertJourneyPage';
import useSubscribeToConsult from '@hooks/subscriptions/useSubscribeToConsult';
import useMyExpert from '@hooks/useMyExpert';
import { GetConsultDocument, GetConsultQuery, GetConsultQueryVariables } from '@typing/Generated';
import { journeyRoute } from '@utils/routeUtils';

type Props = {
  consultId: string;
  journeyId: string;
};

const ExpertJourneyJoinConsultPage = ({ consultId, journeyId }: Props) => {
  const myExpert = useMyExpert();
  const getConsultQuery = useQuery<GetConsultQuery, GetConsultQueryVariables>(GetConsultDocument, {
    variables: { id: consultId }
  });

  useSubscribeToConsult(consultId, () => {
    getConsultQuery.refetch();
  });

  useEffect(() => {
    if (getConsultQuery.data?.consult.joinUrl) {
      window.location.href = getConsultQuery.data.consult.joinUrl;
    }
  }, [getConsultQuery.data?.consult.joinUrl]);

  return (
    <ExpertJourneyPage helmetKey="pageTitles.expertJourney.consult.join" journeyId={journeyId}>
      <HandleQuery query={getConsultQuery}>
        {consultData => (
          <>
            {!consultData.consult.joinUrl && (
              <Redirect to={journeyRoute({ journeyId, linkAfterJourney: '/consults', myExpert })} />
            )}
          </>
        )}
      </HandleQuery>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyJoinConsultPage;
